import { useDebouncedValue } from '@mantine/hooks'
import { useInfiniteQuery, type QueryKey } from '@tanstack/react-query'

export type LoadMoreInfo<Item> = {
	page: number
	perPage: number
	totalCount: number
	items: Item[]
}

export function useLoadMore<Item>(
	queryKey: QueryKey,
	initial: LoadMoreInfo<Item> | null,
	loader: (page: number) => Promise<LoadMoreInfo<Item>>,
) {
	const debouncedQueryKey = useDebouncedValue(JSON.stringify(queryKey), 200)

	return useInfiniteQuery({
		queryKey: [debouncedQueryKey],
		queryFn: async ({ pageParam }) => {
			return loader(pageParam)
		},
		initialData: initial
			? {
					pageParams: [1],
					pages: [initial],
				}
			: undefined,
		initialPageParam: 1,
		getNextPageParam: (lastPage) => {
			return lastPage.page + 1
		},
		getPreviousPageParam: (firstPage) => {
			if (firstPage.page <= 1) {
				return undefined
			}
			return firstPage.page - 1
		},
		staleTime: 0, // useInfiniteQuery has some problem with this
	})
}
